import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './AvailabilityModal.module.scss';
import Typography from '../../kit/atoms/Typography/Typography';
import { AvailibilityOption } from '../../types';
import CheckboxWithLabel from '../../kit/atoms/CheckboxWithLabel/CheckboxWithLabel';
import { useModal } from '../../containers/ModalContext';

interface AvailabilityModalProps extends React.PropsWithChildren<any> {
    filteredAvailabilityOptions: string[];
    availabilityOptions: AvailibilityOption[];
    modalId: string;
    handleAvailabilityOptions: (options: string[]) => void;
}

const AvailabilityModal: React.FC<AvailabilityModalProps> = ({
    filteredAvailabilityOptions,
    availabilityOptions,
    modalId,
    handleAvailabilityOptions
}) => {
    const st: CssModuleType = currentCssModule;
    const { closeModal } = useModal();
    const { t } = useTranslation();
    
    const [filteredAvailability, setFilteredAvailability] = useState<string[]>(filteredAvailabilityOptions);

    const handleAvailabilityOption = (option: string) => {
        const _filteredAvailability = filteredAvailability.some(fa => fa === option) ? filteredAvailability.filter(fa => fa !== option) : [...filteredAvailability, option];
        setFilteredAvailability(_filteredAvailability);
    }

    const isItemActive = (option: AvailibilityOption): boolean => {
        if (!filteredAvailability) return false;
        return filteredAvailability.some(
            (item) => item === option.value
        );
    };

    return (
        <div className={st['availability-modal']}>
            <Typography className={st['availability-modal__title']}>
                {t('/Search/InventoryAvailability')}
            </Typography>
            <Typography className={st['availability-modal__subtitle']}>
                Our products become available for shipping on varying dates.
                Please select the inventory availability time period you would
                like to view.
            </Typography>
            <ul>
                {availabilityOptions?.map((option, ind) => (
                    <li key={option.value}>
                        <CheckboxWithLabel
                            item={option}
                            onToggle={() => handleAvailabilityOption(option?.value)}
                            key={option.value}
                            largeCheckboxes
                            isChecked={isItemActive(option)}
                        />
                    </li>
                ))}
            </ul>
            <div
                className={st['availability-modal__apply']}
                onClick={() => {
                    handleAvailabilityOptions(filteredAvailability);
                    closeModal(modalId);
                }}
            >
                {t('/Search/Apply')}
            </div>
        </div>
    );
};

export default AvailabilityModal;
